module.exports = __webpack_public_path__ + "static/media/task.d05d408c.png";